import { useFormContext } from 'react-hook-form';

import { systemProductCategorySlug } from '../../../../../constants/systemProductCategorySlug';
import GenericSwitchboardSettingsProductSelect from './GenericSwitchboardSettingsProductSelect';

export default function RailSelect({ isDisabled, isRequired = false }) {
  const { watch } = useFormContext();

  const horizontalModules = watch('horizontalModulesPerRow');

  const params = {
    horizontalModules,
    categorySlug: systemProductCategorySlug.Rail
  };

  return (
    <GenericSwitchboardSettingsProductSelect
      isDisabled={isDisabled}
      isRequired={isRequired}
      displayName="Rail"
      inputName="rail"
      params={params}
    />
  );
}
